/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoDirectMessageInput = {
    clientMutationId?: string | null;
    to: string;
    body?: string | null;
    attachments?: Array<DirectMessageAttachment> | null;
};
export type DirectMessageAttachment = {
    identifier: string;
    name: string;
    documentType?: string | null;
};
export type MessageListSendMessageMutationVariables = {
    input: infoDirectMessageInput;
};
export type MessageListSendMessageMutationResponse = {
    readonly infoDirectMessage: {
        readonly clientMutationId: string | null;
        readonly slugs: ReadonlyArray<string>;
    } | null;
};
export type MessageListSendMessageMutation = {
    readonly response: MessageListSendMessageMutationResponse;
    readonly variables: MessageListSendMessageMutationVariables;
};



/*
mutation MessageListSendMessageMutation(
  $input: infoDirectMessageInput!
) {
  infoDirectMessage(input: $input) {
    clientMutationId
    slugs
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoDirectMessagePayload",
    "kind": "LinkedField",
    "name": "infoDirectMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slugs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageListSendMessageMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageListSendMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e2838d7e2bf5204c775fe150097539c9",
    "id": null,
    "metadata": {},
    "name": "MessageListSendMessageMutation",
    "operationKind": "mutation",
    "text": "mutation MessageListSendMessageMutation(\n  $input: infoDirectMessageInput!\n) {\n  infoDirectMessage(input: $input) {\n    clientMutationId\n    slugs\n  }\n}\n"
  }
};
})();
(node as any).hash = '2c27c6919a6771e929c6e0734d7d64a9';
export default node;
